import { Injectable } from '@angular/core';
import {BASE_URL} from '../constants';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BrowseDocuments} from '../../models/browseDocuments.model';
import {htmlDocument} from '../../models/htmlDocument.model';
import {map} from 'rxjs/operators';
import {Entity} from '../../models/entity.model';

@Injectable({
  providedIn: 'root'
})
export class PdfEntitiesService {

  URL = BASE_URL + '/text/';
  constructor(private http: HttpClient) { }

  public upload(formData: htmlDocument): Observable<any> {
    return this.http.post<any>(this.URL + 'entities/update/', formData);
  }

  public saveAndDownload(formData: htmlDocument): Observable<any> {
    return this.http.post<any>(this.URL + 'entities/update_and_download/', formData, { responseType: 'blob' as 'json'});
  }

}
